export default {
  'report.add': '新增报备',
  'report.records': '报备记录',
  'report.project': '意向项目',
  'report.project.placeholder': '请输入意向项目',
  'report.city': '所在城市',
  'report.hospital': '查重医院',
  'report.hospital.placeholder': '请选择医院',
  'report.images': '图片',
  'report.images.placeholder': '请上传图片',
  'report.msg': '备注',
  'report.msg.placeholder': '请输入备注',
  'report.state': '查重状态',
};
